export * from './format-coupon';
export * from './to';
export * from './storage-helper';
export const IS_DEBUG =
  location.href.includes('localTime=1') || location.href.includes('serverTime');

/**
 * 补齐数字位数，例如：1 => 001
 * @param num 数字或数字字符串
 * @param digits 位数
 */
export function fillNum(num: number | string, digits: number) {
  const numStr = `${num}`;
  const lengthDiff = digits - numStr.length;
  if (lengthDiff > 0) return Array(lengthDiff).fill('0')
    .join('') + numStr;
  return numStr;
}

/**
 * 缓存图片列表
 * @param imgList 图片列表
 */
export function cacheImg(imgList: string[]) {
  imgList.forEach((img) => {
    (new Image).src = img;
  });
}

/**
 * 尝试进行decodeURIComponent
 * @param {url} url
 * @returns
 */
export const tryDecode = (url) => {
  let newURL = url;
  try {
    newURL = decodeURIComponent(url);
  } catch (err) { }
  return newURL;
};

/**
 * 计算并格式化百分比，返回的数据区间[1,99].
 * 使用场景：如券剩余库存
 * @param sent 已占用量
 * @param total 总量
 * @returns 剩余量%
 */
export const formatPercent = (sent: number, total: number) => {
  const result = ((total - sent) / total) * 100;
  return String(Math.min(100, Math.max(1, result))).split('.')[0];
};

/** 获取元素顶部距离根元素的高度 */
export const getElementTop = (el: HTMLElement) => {
  let actualTop = el.offsetTop;
  let current = el.offsetParent as HTMLElement;
  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent as HTMLElement;
  }
  return actualTop;
};
/** 是否滚动到底部 */
export function isScrollToEnd() {
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
  const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
  return scrollTop + clientHeight >= scrollHeight;
}
/** 页面滚动距离 */
export function getOffsetY() {
  const { pageYOffset } = window;
  const documentScrollTop = document.documentElement.scrollTop;
  const bodyScrollTop = document.body.scrollTop;
  return pageYOffset || documentScrollTop  || bodyScrollTop;
};

/**
 * 等待指定时间
 * @param time 毫秒数
 */
export function wait(time: number) {
  return new Promise((resolve) => {
    setTimeout(resolve, time);
  });
}
